import React from 'react'
import { shallow } from 'enzyme'

import EditorFooter from '../../features/TextEditor/EditorFooter'
import createToolbarWithPlugin from '../../features/TextEditor/createToolbarWithPlugin'

describe('EditorFooter', () => {
  let wrapper, props, result, instance
  const { ToolbarComponent } = createToolbarWithPlugin()
  beforeEach(() => {
    props = {
      published: false,
      disabled: false,
      predefined: true,
      questionStatus: '',
      isBankUser: false,
      onPostClick: jest.fn(),
      onSaveAsDraftClick: jest.fn(),
      onLinkButtonClick: jest.fn(),
      onDeleteClick: jest.fn(),
      onFileUploadClick: jest.fn(),
      ToolbarComponent : ToolbarComponent,
    },
    wrapper = shallow(<EditorFooter {...props} />)
    instance = wrapper.instance()
  })
  describe('#render', () => {
    describe('when published is set to false', () => {
      it('should have save as draft and publish to bank', () => {
        const saveAsDraftButton = wrapper.find('EditorFooter__SaveAsDraftButton').at(0)
        const postButton = wrapper.find('EditorFooter__PostButton').at(0)
        expect(saveAsDraftButton).toHaveLength(1)
        expect(postButton).toHaveLength(1)
        expect(saveAsDraftButton.childAt(0).text()).toBe('Save as Draft')
      })
    })
    describe('when published is set to true', () => {
      it('should not have save as draft but have publish to bank ', () => {
        props.published = true
        wrapper = shallow(<EditorFooter {...props} />)
        instance = wrapper.instance()
        const saveAsDraftButton = wrapper.find('EditorFooter__SaveAsDraftButton').at(0)
        const postButton = wrapper.find('EditorFooter__PostButton').at(0)
        expect(saveAsDraftButton).toHaveLength(0)
        expect(postButton).toHaveLength(1)
      })
    })
    describe('when predefined is set to false', () => {
      it('should not have delete button', () => {
        const deleteBtn = wrapper.find('EditorFooter__DeleteButton').at(0)
        expect(deleteBtn).toHaveLength(0)
      })
    })
    describe('when predefined is set to true', () => {
      it('should have delete button', () => {
        props.predefined = false
        wrapper = shallow(<EditorFooter {...props} />)
        instance = wrapper.instance()
        const DeleteText = 'Delete'
        const deleteBtn = wrapper.find('EditorFooter__DeleteButton').at(0)
        expect(deleteBtn).toHaveLength(1)
        expect(deleteBtn.childAt(0).text()).toBe(DeleteText)
      })
    })
  })
  
})